export enum ArtifactIdType {
  ScopeOneId = 'SCOPEONEID',
  EsgId = 'ESGID',
  EasyNumber = 'EASYNUMBER',
}
